import React from 'react';
import '../Copyrights/Copyright.css';




function Copyright() {
  return (
    <div className='copyright'>
        <div className='text'>
            <p>© 2022 hakeem.dev</p>
        </div>
    </div>
  )
}


export default Copyright;